export const environment = {
  production: true,
  API_HOST: 'https://api.cc-irdigital.pe',
  API_REX: 'https://api.cc-irdigital.pe/rex/rex-api-requests',
  API_SECURITY: 'https://api.cc-irdigital.pe/public/cc-auth-svc',
  API_FILE_MANAGER: 'https://api.cc-irdigital.pe/integracion/cc-file-svc',
};
